import { Link } from '@tanstack/react-router';
import useReveal from '../../hooks/useReveal.js';
import Button from '../ui/Button.jsx';
import Eyebrow from '../ui/Eyebrow.jsx';
import SplitText from '../ui/SplitText.jsx';
import HeroCube from '../primitives/HeroCube.jsx';
import { hero } from '../../content/site.js';

/**
 * Hero — flat dark section with the ambient cube video on the right.
 * Background aurora/grid washes were removed (clashed with the cube); the
 * headline uses SplitText for a letter-by-letter reveal.
 *
 * No props. The primary CTA is a plain router link to /intake.
 */
export default function Hero() {
  const subRef = useReveal();
  const ctaRef = useReveal();

  return (
    <section className="relative overflow-hidden isolate pt-40 pb-12 bg-surface text-ink-50">
      {/* Ambient cube video — anchored to the right edge */}
      <HeroCube />

      <div className="container-page relative z-10">
        {/* Content column — kept left of the cube on desktop */}
        <div className="lg:max-w-[600px] xl:max-w-[640px]">
          {/* Status line */}
          <Eyebrow className="text-mono-sm tracking-[0.12em]">{hero.status}</Eyebrow>

          {/* Headline */}
          <h1 className="mt-7 mb-6 text-display-2xl max-w-[18ch]">
            <SplitText text={hero.headline} accent={hero.headlineAccent} />
          </h1>

          {/* Subhead */}
          <p ref={subRef} className="reveal sub max-w-[62ch] mb-9 text-body-lg text-ink-200">
            {hero.subhead}
          </p>

          {/* CTAs */}
          <div ref={ctaRef} className="reveal flex flex-wrap gap-3">
            <Button variant="primary" as={Link} to={hero.ctaPrimary.href}>
              {hero.ctaPrimary.label}
            </Button>
            <Button variant="ghost" href={hero.ctaSecondary.href}>
              {hero.ctaSecondary.label}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
